import {
  REQUEST_CURRENT_USER_DETAILS,
  RECEIVE_CURRENT_USER_DETAILS,
  REQUEST_CURRENT_USER_DETAILS_FAILURE,
  RECEIVE_FEATURES
} from '../constants/actionTypes';

export function getCurrentUserDetails(id) {
  return {
    type: REQUEST_CURRENT_USER_DETAILS,
    id,
  };
}

export function receiveCurrentUserDetails(userDetails) {
  return {
    type: RECEIVE_CURRENT_USER_DETAILS,
    userDetails,
  };
}

export function failureCurrentUserDetails(error) {
  return {
    type: REQUEST_CURRENT_USER_DETAILS_FAILURE,
    error,
  };
}

export function receiveFeatures(featureKeys, values) {
  return {
    type: RECEIVE_FEATURES,
    keys: featureKeys,
    values,
  };
}